import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/landing';
import CreamShopPage from '../pages/creamShop';
import FightPage from '../pages/fight';
import MarketPage from '../pages/market';
import TestingPage from '../pages/testing';
import PageNotFound from '../pages/PageNotFound';

export const LoggedOutRoutes = () => (
  <Routes>
    <Route path='/' element={<LandingPage />} />
    <Route path='/mobileapp' element={<LandingPage hideDownload />} />
    <Route path='/market' element={<LandingPage market />} />
    <Route path='*' element={<PageNotFound />} />
  </Routes>
);

export const LoggedInRoutes = () => (
  <Routes>
    <Route path='/' element={<FightPage />} />
    <Route path='/creamshop' element={<CreamShopPage />} />
    <Route path='/creamshop/:view' element={<CreamShopPage />} />
    <Route path='/market' element={<MarketPage />} />
    <Route path='/about' element={<LandingPage />} />
    {process.env.NODE_ENV === 'development' && (
      <Route path='/testing' element={<TestingPage />} />
    )}
    <Route path='*' element={<PageNotFound />} />
  </Routes>
);
